import { render } from "./FeedbackSection.vue?vue&type=template&id=8c3319e6"
import script from "./FeedbackSection.vue?vue&type=script&lang=js"
export * from "./FeedbackSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__